@if (startopdrachten().length > 0) {
  <section class="py-10">
    <div class="text-center">
      <div class="flex flex-col gap-y-2 container-1-col">
        <h2 class="mb-2">Aan de slag</h2>

        <div class="flex flex-col gap-2">
          @for (opdracht of startopdrachten() | slice: 0 : 2; track opdracht) {
            <div
              class="clickable-card-200 p-4 rounded overflow-hidden cursor-pointer flex flex-row justify-between items-center gap-2 has-[:focus-visible]:outline-[3px] has-[:focus-visible]:outline-[yellow] has-[:focus-visible]:outline-dashed has-[:focus-visible]:outline-offset-[2px]"
            >
              <div class="flex flex-row">
                <div>
                  <parkour-badge
                    [width]="'w-12'"
                    [icon]="opdracht.icon"
                    class="flex"
                    [theme]="'s-100'"
                  />
                </div>
                <parkour-action
                  (clicked)="onStartopdrachtClicked(opdracht)"
                  classes="before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:z-10 focus-visible:outline-none"
                >
                  <div class="text-left ml-4">
                    {{ opdracht.title }}
                    <p class="text-n-700 font-normal">{{ opdracht.body }}</p>
                  </div>
                </parkour-action>
              </div>
              <parkour-icon size="3" [classes]="'text-n-600'" [name]="'info-circle'" />
            </div>
          }
        </div>
      </div>
    </div>
  </section>
}
